<template>
    <b-button @click="$emit('expandToggle')" variant="outline-primary">
        <img src="@/assets/icons/expandir.svg" />
        <div class="label">
            {{ $t('expand') }}
        </div>
    </b-button>
</template>

<script>
export default {
    name: 'ExpandAllOkrsBtn',
    i18n: {
        messages: {
            'en-US': {
                expand: 'Expand',
            },
            'es-ES': {
                expand: 'Ampliar',
            },
            'pt-BR': {
                expand: 'Expandir',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 0.5rem;
    align-self: center;
    margin-left: auto;
    font-weight: 700;
    font-size: 0.9rem;
    color: #009ada;
    border: solid 2px #009ada;
}
.btn:hover,
.btn:active {
    background-color: transparent !important;
    color: #009ada !important;
    border-color: #009ada !important;
}

@media only screen and (max-width: 1300px) {
    .label {
        display: none;
    }
}
</style>
